import { createSelector } from 'reselect';

import { sortByOrderNumber, getSorterByField } from './../orderSorters';
import { getOrderIdsWithUnreadMessages } from './../notification/selectors';

const stable = require('stable');

export const getOrderList = state =>
  state.ordersProgress.numbers.map(number => state.orders[number]).filter(o => !o.is_full_refunded);
const getSorting = state => state.ordersProgress.sorting;
const getFilter = state => state.ordersProgress.filter;
const getChatNotifications = state => state.clientChatNotifications.notifications;

const filterBySearch = (filterSearch, orderList) =>
  (!filterSearch ? orderList : orderList.filter(item => item.number.toLowerCase().indexOf(filterSearch.toLowerCase()) > -1));

const ordersFiltererSorter = (filter, sorting, unreadOrderIds, orderList, chatNotifications) => {
  let orders = orderList;
  if (filter.search) {
    orders = filterBySearch(filter.search, orderList);
  }
  if (filter.new_messages) {
    orders = orderList.filter(order => unreadOrderIds.includes(order._id) || (order.jabber_node && chatNotifications.find(o => o.node === order.jabber_node && o.count > 0)));
  }
  const ordersSortedByNumber = stable(orders, sortByOrderNumber);
  const sorter = getSorterByField(sorting.field, sorting.isAsc, unreadOrderIds);
  return stable(ordersSortedByNumber, sorter);
};

export const getOrdersProgressSorted = createSelector([getFilter, getSorting, getOrderIdsWithUnreadMessages, getOrderList, getChatNotifications], ordersFiltererSorter);
